import { render, staticRenderFns } from "./project-weekly-report-download.vue?vue&type=template&id=60af5124&scoped=true&"
import script from "./project-weekly-report-download.vue?vue&type=script&lang=js&"
export * from "./project-weekly-report-download.vue?vue&type=script&lang=js&"
import style0 from "./project-weekly-report-download.vue?vue&type=style&index=0&id=60af5124&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af5124",
  null
  
)

export default component.exports